'use client';

import { createContext } from 'react';

import { WizardContextType } from './types';

// ----------------------------------------------------------------------

export const WizardContext = createContext({} as WizardContextType);
